import { BankSpecificStatus } from "types";

export type SelectableBank = "BANK_NOW" | "CEMBRA_MONEY_AG" | "CORNER";

// Same order as the bank tabs in Selekcija banaka.
export const SELECTABLE_BANKS: SelectableBank[] = ["BANK_NOW", "CEMBRA_MONEY_AG", "CORNER"];

// Bank statuses from which a contract ("O kreditu") exists, ordered from least to most advanced.
export const CONTRACT_BANK_STATUSES: BankSpecificStatus[] = [
  "APPROVED",
  "SIGNING",
  "SIGNING_SUSPENDED",
  "CONTRACT_VERIFICATION",
  "SIGNED_COMPLETE",
];
